import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import type { NextPage } from 'next';
// import FeaturesList from 'modules/Marketing/components/FeaturesList';
// import GetInfoSection from 'modules/Marketing/components/GetInfoSection';
// import MissionOrCandidate from 'modules/Marketing/components/MissionOrCandidate';
import { event } from 'modules/Analytics';
// import { whatsappDorothee } from 'modules/App/config';
import { useAuthModal } from 'modules/auth';
import dayjs from 'lib/helpers/date';
import config from 'modules/App/config';
import { Button } from '@/lib/components/ui/button';
import Hero from 'lib/components/ui/hero';
import Highlight from 'modules/common/components/Highlight';
import Section from 'modules/common/components/Section';
import TestimonialOfferList from 'modules/App/components/TestimonialOfferList';
import usePageProps from 'modules/common/hooks/usePageProps';
import { useRouter } from 'next/navigation';
import React from 'react';
import Avatars from '@/lib/components/ui/avatars';
import Stat from '@/lib/components/ui/stat';
import AppFAQ from 'modules/App/components/AppFAQ';
import { formatCurrency } from '@/lib/helpers/strings';
import InfiniteRibbon from '@/lib/components/ui/infinite-ribbon';
import BenefitsGrid from '@/lib/components/ui/benefits-grid';
import TextRotate from '@/lib/components/ui/text-rotate';
import FeatureScrollSection from '@/lib/components/ui/feature-scroll-section';
import WorkflowScrollSection from '@/lib/components/ui/workflow-scroll-section';
import Head from 'next/head';
import Image from 'next/image';

// const BulletSvg = () => (
//   <svg className="shrink-0 mr-3" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
//     <circle className="fill-primary" cx="10" cy="10" r="10" />
//     <path
//       className="fill-white"
//       d="M15.335 7.933 14.87 7c-4.025 1.167-6.067 3.733-6.067 3.733l-1.867-1.4-.933.934L8.802 14c2.158-4.025 6.533-6.067 6.533-6.067Z"
//     />
//   </svg>
// );

const GoogleRating = () => (
  <div className="flex items-center gap-2">
    <div className="text-right">
      <div className="flex items-center gap-1 justify-end mb-1">
        <span className="text-2xl font-bold text-gray-900">5.0</span>
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <span key={i} className="text-yellow-400 text-lg">
              ★
            </span>
          ))}
        </div>
      </div>
      <p className="text-xs text-blue-600">10 avis google</p>
    </div>
    <div className="ml-2">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <g>
          <path
            d="M36.09 20.46c0-1.36-.12-2.36-.38-3.39H20.41v6.16h8.98c-.18 1.5-1.16 3.76-3.34 5.29l-.03.22 4.85 3.77.34.03c3.13-2.89 4.88-7.15 4.88-12.08z"
            fill="#4285F4"
          />
          <path
            d="M20.41 37c4.42 0 8.13-1.46 10.84-3.98l-5.17-4.02c-1.39.97-3.26 1.65-5.67 1.65-4.33 0-8-2.93-9.31-6.98l-.2.02-5.06 3.92-.07.19C8.74 33.36 14.13 37 20.41 37z"
            fill="#34A853"
          />
          <path
            d="M11.1 23.67c-.32-.96-.5-1.99-.5-3.04s.18-2.08.48-3.04l-.01-.2-5.13-3.99-.17.08A16.56 16.56 0 0 0 3.41 20.63c0 2.7.65 5.25 1.8 7.48l5.9-4.44z"
            fill="#FBBC05"
          />
          <path
            d="M20.41 11.57c3.08 0 5.16 1.33 6.35 2.44l4.63-4.53C28.5 6.97 24.83 5 20.41 5 14.13 5 8.74 8.64 6.11 13.89l5.99 4.44c1.31-4.05 4.98-6.76 8.31-6.76z"
            fill="#EA4335"
          />
        </g>
      </svg>
    </div>
  </div>
);

const HomePage: NextPage = () => {
  const { toggleModal, session } = useAuthModal();
  const router = useRouter();
  const { pageProps: { stats, avatars } = {} as any } = usePageProps() || {};

  const signin = (url = '/my-missions') => {
    !!session ? router.push(url) : toggleModal();
  };

  // const items = [
  //   {
  //     value: stats?.nbMembers,
  //     label: 'Membres actifs',
  //     moreInfo: (
  //       <>
  //         et <strong>sympas</strong>
  //       </>
  //     ),
  //   },
  //   {
  //     value: stats?.nbSearchedProfiles,
  //     label: 'Postes à pourvoir',
  //     moreInfo: 'en ce moment',
  //     aosDelay: 100,
  //   },
  //   {
  //     value: stats?.nbContacts,
  //     label: 'Mises en relation',
  //     moreInfo: 'networking facile',
  //     aosDelay: 200,
  //   },
  //   {
  //     value: stats?.nbAvailableProfiles,
  //     label: 'Candidats Off-Market',
  //     moreInfo: 'dispos maintenant',
  //     aosDelay: 100,
  //   },
  //   // { value: stats?.nbContacts, label: 'Candidats recommandés', aosDelay: 200 },
  //   {
  //     value: formatCurrency({ value: stats?.bountyAmount, locale: 'fr' }),
  //     label: 'Primes à octroyer',
  //     moreInfo: 'place ton candidat',
  //     aosDelay: 200,
  //   },
  // ];

  const abtests = {
    hero: {
      title: (
        <>
          Transforme tes <Highlight className="my-1">candidats non retenus</Highlight>
          <br />
          en <Highlight>opportunités</Highlight>
        </>
      ),
      subtitle: (
        <>
          Le 1er club sélectif qui permet aux recruteurs d’<strong>augmenter leurs revenus</strong> en rentabilisant tout le temps investi en
          sourcing.
        </>
      ),
    },
    hero2: {
      title: <>Transforme ta boîte actuelle en celle dont tu as toujours rêvé !</>,
      subtitle: (
        <>
          Gérer le quotidien et structurer sa société sont 2 sujets difficiles à mener de front. Remplis notre questionnaire pour être guidé pas à
          pas.
        </>
      ),
    },
  };
  const abtest = abtests.hero;

  return (
    <HeaderLayout>
      <Head>
        <link rel="preload" as="image" href="/images/marketing/transform-ton-temps-en-revenu-potentiel.png" />
      </Head>
      <Hero
        ratio="3:2"
        meta="Le club des meilleurs recruteurs"
        variant="image"
        image="/images/marketing/transform-ton-temps-en-revenu-potentiel.png"
        imageAlt="Transforme ton temps en revenu potentiel"
        title={
          <TextRotate
            as="span"
            texts={[
              <>
                <span>Transforme tes </span>
                <Highlight>candidats non retenus</Highlight>
                <span> en </span>
                <Highlight>opportunités</Highlight>
              </>,
              <>
                <span>Délègue ton </span>
                <Highlight>sourcing</Highlight>
                <span> à des </span>
                <Highlight>recruteurs de confiance</Highlight>
              </>,
              <>
                <span>Reste informé des </span>
                <Highlight>meilleures pratiques</Highlight>
                <span> et </span>
                <Highlight>outils du marché</Highlight>
              </>,
            ]}
            mainClassName="flex flex-wrap gap-1"
            staggerFrom="first"
            animatePresenceMode="wait"
            staggerDuration={0.01}
            splitBy="characters"
            initial={[{ filter: 'blur(10px)', opacity: 0.5 }]}
            animate={[{ filter: 'blur(0px)', opacity: 1 }]}
            exit={[{ filter: 'blur(10px)', opacity: 0.5 }]}
            loop
            transition={{ ease: [0.9, 0.151, 0.153, 0.01], duration: 1 }}
            rotationInterval={3500}
            firstRotationInterval={1500}
          />
        }
        description={abtest.subtitle}
        cta={
          <div className="flex flex-col sm:flex-row gap-3 items-center">
            <Button
              onClick={() => {
                signin();
                event({ action: 'cta-home-hero', category: 'home', label: 'cta-home-hero' });
              }}
              variant="cta"
            >
              Postule gratuitement
            </Button>
            <Button href="/avantages" variant="outline-primary">
              Découvre les avantages
            </Button>
          </div>
        }
        footer={
          <div className="flex flex-wrap items-center gap-2">
            <Avatars avatars={avatars} max={13} count={stats?.nbMembers} />
            <span className="text-sm text-faded">
              Déjà utilisé par <strong className="text-black">{stats?.nbMembers}</strong> recruteurs
            </span>
          </div>
        }
      />

      <FeatureScrollSection
        title="Booste tes résultats grâce à notre réseau de recruteurs de confiance"
        subtitle="Une mission que tu ne peux pas prendre ? (pas le temps ou en dehors de ton scope) : propose la aux autres membres et partage la commission ! Un creux d'activité ? Viens sourcer pour les autres ! Flemme de prospecter, pb de recouvrement, de clause de remplacement  ? Viens en discuter avec tes pairs !"
        items={[
          {
            title: 'Propose tes candidats non retenus à d’autres cabinets',
            description:
              "Chaque semaine, des heures sont passées à trouver et contacter des candidats. Pourtant, 90% d'entre eux ne sont pas recrutés… et finissent oubliés dans ton ATS. En les proposant aux autres membres du club, tu marqueras des points auprès de tes candidats, et s’ils sont recrutés, tu toucheras une commission.",
            image: '/images/marketing/screenshot-cvtheque.png',
          },
          {
            title: 'Sollicite un coup de main pour ton sourcing',
            description:
              'Le perfect match pour ton client vient peut-être d’être préqualifié par un autre cabinet, qui n’avait rien à lui proposer. Accès à notre CVThèque exclusive, ou délègue le sourcing à un autre recruteur spécialisé.',
            image: '/images/marketing/screenshot-missions.png',
          },
          {
            title: 'Vient échanger avec les meilleurs cabinets',
            description:
              'Le marché, les outils, les pratiques évoluent à toute vitesse. Assiste à nos masterclass, échange avec d’autres cabinets à l’occasion de nos cafés virtuels ou apéros en présentiel.',
            image: '/images/marketing/screenshot-map.png',
          },
        ]}
        ratio="5:4"
      />

      <Section title="Comment Headlinker simplifie ton recrutement" bgColor="bg-gray-50">
        <div className="grid gap-4 md:grid-cols-3 mt-12 md:h-[300px]">
          <article className="h-full flex flex-col">
            <h2 className="text-base mb-5">Trouve tes partenaires</h2>
            <Stat
              className="flex-1"
              variant="primary"
              value={stats?.nbMembers}
              description="recruteurs séléctionnés sur +900 rencontrés"
              meta="100% de confiance"
              size="md"
            />
          </article>
          <article className="h-full flex flex-col">
            <h2 className="text-base mb-5 whitespace-nowrap">Valorise tes candidats non sélectionnés</h2>
            <Stat
              className="flex-1"
              variant="success"
              value={formatCurrency({ value: Math.floor((stats?.bountyAmount ?? 0) / 10000) * 10000, locale: 'fr', compact: true })}
              description="de primes pour des missions qui ont besoin de candidats"
              meta="Replace tes candidats"
              size="md"
            />
          </article>
          <article className="h-full flex flex-col">
            <h2 className="text-base mb-5">Trouve des candidats pour ta mission</h2>
            <Stat
              className="flex-1"
              variant="accent"
              value={stats?.nbAvailableProfiles}
              description="candidats off-market préqualifiés par les meilleurs cabinets"
              meta="disponibles immédiatement"
              size="md"
            />
          </article>
        </div>
        <p className="text-center text-sm text-gray-500 mt-4">
          *Données basées sur <strong>{stats?.nbContacts}</strong> mises en contact
        </p>
        <div className="text-center mt-4">
          <Button variant="outline-primary" href="/avantages">
            Découvre les avantages
          </Button>
        </div>
      </Section>

      <WorkflowScrollSection
        title="Ne perds plus 90% de tes candidats sourcés&nbsp;: transforme-les en revenus"
        subtitle="Réutilise, valorise et monétise tes profils pour transformer chaque recherche en investissement rentable."
        topRight={
          <div className="flex items-center justify-end gap-2">
            <Button
              onClick={() => {
                signin();
                event({ action: 'cta-workflow-scroll', category: 'home', label: 'cta-workflow-scroll' });
              }}
              variant="cta"
              className="ml-auto"
            >
              Postule gratuitement
            </Button>
          </div>
        }
        items={[
          {
            content: (
              <div className="relative w-full aspect-[16/9]">
                <Image
                  src="/images/marketing/candidats-non-retenus-1.png"
                  alt="Stocke tes candidats"
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 600px"
                  className="object-contain rounded-lg"
                  loading="lazy"
                />
              </div>
            ),
            title: 'Stocke tes candidats',
            subtitle: 'Tes candidats non retenus ne dorment plus dans un Excel. Stocke-les comme ressource potentielle.',
            variant: 'default',
          },
          {
            content: (
              <div className="relative w-full aspect-[16/9]">
                <Image
                  src="/images/marketing/candidats-non-retenus-2.png"
                  alt="Partage avec le réseau"
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 600px"
                  className="object-contain rounded-lg"
                  loading="lazy"
                />
              </div>
            ),
            title: 'Partage avec le réseau',
            subtitle: 'Tes candidats trouvent preneur via le réseau. Chaque profil devient une opportunité monétisable.',
            variant: 'primary',
          },
          {
            content: (
              <div className="flex justify-end items-end w-full">
                <div className="flex flex-col items-center justify-center bg-success-lighter border-2 border-success rounded-lg px-6 py-4">
                  <div className="text-4xl font-bold text-success">
                    {formatCurrency({ value: stats?.bountyAmount ?? 0, locale: 'fr', compact: true })}
                  </div>
                  <div className="text-sm text-success mt-2 text-center">de primes à octroyer</div>
                </div>
              </div>
            ),
            title: 'Empoche ta prime',
            subtitle: 'Transforme ton sourcing en revenus grâce aux primes du réseau.',
            variant: 'success',
          },
        ]}
      />

      {/* <ImageSection /> */}
      <Section
        center={false}
        ratio="4:3"
        title="Avantages exclusifs inclus dans ton abonnement"
        subtitle="Tu accédes aussi à des ateliers, formations et événements qui t'aident à mieux recruter, développer ton activité et rester à jour sur les meilleures pratiques."
        topRight={
          <div className="relative sm:-mt-32 w-full aspect-[16/9]">
            <Image
              src="/images/marketing/next-events.png"
              alt="Avantages exclusifs"
              fill
              sizes="(max-width: 768px) 100vw, 400px"
              className="object-contain rounded-lg"
              loading="lazy"
            />
          </div>
        }
      >
        <BenefitsGrid
          items={[
            {
              icon: '🎓',
              title: 'Formations & masterclass',
              description: 'Réduis de moitié ton sourcing grâce à la réutilisation intelligente de tes candidats.',
              highlight: 'environ 25% de ton sourcing ré-utilisé',
            },
            {
              icon: '⚒️',
              title: 'Ateliers pratiques',
              description: 'Participe à des sessions collaboratives pour améliorer ton prospection, ton sourcing et ton organisation.',
              highlight: '+20 sessions/an',
            },
            {
              icon: '🤝',
              title: 'Coaching & communauté',
              description: "Rejoins un réseau d'indépendants qui partagent outils, expériences et opportunités.",
              highlight: `déjà ${stats?.nbMembers} recruteurs formés`,
            },
          ]}
        />
        <div className="text-center mt-8">
          <Button variant="primary" href="/avantages">
            Découvre les avantages
          </Button>
        </div>
      </Section>
      {dayjs().isBefore(dayjs(config.endStarter239Date)) && (
        <InfiniteRibbon variant="primary" repeat={8} duration={18} onClick={() => router.push('/abonnement')}>
          <span className="font-semibold" suppressHydrationWarning>
            🔥 Offre limitée jusqu&apos;au {dayjs(config.endStarter239Date).format('DD MMMM YYYY')} - Profite du tarif réduit maintenant !
          </span>
        </InfiniteRibbon>
      )}
      <Section bgColor="bg-primary-50" title={'Ils ont déjà simplifié leur recrutement avec Headlinker'} id="testimonials">
        <div className="flex justify-center">
          <GoogleRating />
        </div>
        <TestimonialOfferList type="cards" className="my-12" />
      </Section>
      {/* <Section
        bgColor="bg-gray-50"
        title={'Pas de vol de candidats ou de clients'}
        subtitle={
          <>
            Chez Headlinker, tes clients et candidats ne sont pas mis en commun dans un ATS. Tu décides de les partager avec les recruteurs qui te
            semblent pertinents.
          </>
        }
      >
        <div className="mx-auto max-w-2xl mt-5">
          <ol className="list-decimal flex flex-col gap-3">
            <li>
              <strong className="block">Nous sélectionnons personnellement les recruteurs du réseau</strong>
              <div className="text-faded ">
                ✅ <span className="italic">100% de recruteurs expérimentés</span>
              </div>
            </li>
            <li>
              <strong className="block">Ton candidat reste anonyme pour l’autre recruteur jusqu’à ce que tu aies échangé avec lui</strong>
              <div className="text-faded">
                ✅ <span className="italic">Pas de risque de te faire voler ton candidat, uniquement son profil anonymisé est partagé</span>
              </div>
            </li>
            <li>
              <strong className="block">Si sa proposition t’intéresse, tu partages l’identité de ton candidat</strong>
              <div className="text-faded">
                ✅ <span className="italic">Une fois encore, c’est toi qui décide</span>
              </div>
            </li>
          </ol>
        </div>
      </Section>
      <Section
        className="bg-gray-50"
        title={<>Headlinker, ç’est pour qui&nbsp;?</>}
        subtitle={
          <>
            Headlinker est la plateforme dédiée aux recruteurs indépendants et cabinets qui souhaitent optimiser leur activité, développer leur réseau
            et maximiser leurs placements grâce à un écosystème collaboratif et sécurisé.
          </>
        }
      >
        <div className="aspect-video w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow-lg mt-8 relative">
          {!seenVideo && (
            <div
              className="absolute inset-0 z-10 cursor-pointer video-overlay bg-transparent"
              onClick={() => {
                track('video.played', {
                  video_title: 'Présentation Headlinker',
                  video_id: '9x7S2hrWIzU',
                });

                videoRef.current?.click();
                setSeenVideo(true);
              }}
            />
          )}
          <iframe
            ref={videoRef}
            className="w-full h-full"
            src="https://www.youtube.com/embed/9x7S2hrWIzU"
            title="Présentation Headlinker"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="text-center mt-4">
          <button
            className="btn btn-outline btn-sm"
            onClick={() => {
              track('video.see-all', {
                source: 'homepage',
              });
              window.open(youtubeChannelUrl, '_blank');
            }}
          >
            Voir toutes nos vidéos
          </button>
        </div>
      </Section> */}

      {/* <Section
        id="pricing"
        title={<>Et ça coute combien Headlinker&nbsp;?</>}
        subtitle="Notre service de base est soumis à une cotisation annuelle et une paiement au succès, afin que vous puissiez vous familiariser facilement avec la plateforme et la communauté"
      >
        <Pricing className="mt-5" />
        <div className="text-center mt-5">
          <p className="text-sm text-gray-500 mt-12 mb-2">
            Accès immédiat à une communauté expérimentée et de confiance pour t’accompagner vers des résultats rapides.
          </p>
          <Button className="btn btn-primary" onClick={toggleModal}>
            Postule gratuitement
          </Button>
        </div>
      </Section> */}
      {/* <MissionOrCandidate /> */}
      {/* <GetInfoSection /> */}

      {/* <FeaturesList /> */}

      <Section id="faq" title="Les recruteurs nous demandent souvent" subtitle="Questions fréquentes">
        <AppFAQ className="mt-12" />
        <div className="text-center mt-5">
          <Button
            variant="cta"
            onClick={() => {
              signin();
              event({ action: 'cta-home-faq', category: 'home', label: 'cta-home-faq' });
            }}
          >
            Postule gratuitement
          </Button>
        </div>
      </Section>
    </HeaderLayout>
  );
};

export default HomePage;
